// Add-ons a client ticks in the booking form (design ds-addons).
//
// The server prices and books the longer appointment (task d3-addon-pricing),
// so the picker is on. REACT_APP_ADD_ON_PICKER=false switches it off again, and
// the booking form then shows nothing new.
export const isAddOnPickerEnabled = () =>
  String(process.env.REACT_APP_ADD_ON_PICKER || "").trim().toLowerCase() !== "false";

const toMinutes = (value) => {
  const minutes = Number(value);
  return Number.isInteger(minutes) && minutes > 0 ? minutes : 0;
};

const toPrice = (value) => {
  const price = Number(value);
  return Number.isFinite(price) && price > 0 ? price : 0;
};

// The add-ons a service offers, in the order the pro set, with only what the
// booking form needs. Add-ons without an id can't be booked, so they're left out.
export const offeredAddOns = (service) =>
  (Array.isArray(service?.addOns) ? service.addOns : [])
    .filter((addOn) => addOn && addOn._id)
    .map((addOn) => ({
      id: String(addOn._id),
      title: typeof addOn.title === "string" ? addOn.title.trim() : "",
      price: toPrice(addOn.price),
      durationMinutes: toMinutes(addOn.durationMinutes),
    }));

// The ticked add-ons, in the pro's order rather than the order they were ticked.
export const selectedAddOns = (service, ids = []) => {
  const picked = new Set((ids || []).map(String));
  return offeredAddOns(service).filter((addOn) => picked.has(addOn.id));
};

export const addOnTotals = (addOns = []) =>
  addOns.reduce(
    (totals, addOn) => ({
      minutes: totals.minutes + toMinutes(addOn.durationMinutes),
      price: totals.price + toPrice(addOn.price),
    }),
    { minutes: 0, price: 0 },
  );

// "2 hr 50 min", "45 min", "2 hr", as the design writes lengths. Each number
// keeps its unit (a non-breaking space) so "50 / min" never splits a line.
export const formatLength = (totalMinutes) => {
  const minutes = toMinutes(totalMinutes);
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return `${rest}\u00a0min`;
  return rest ? `${hours}\u00a0hr ${rest}\u00a0min` : `${hours}\u00a0hr`;
};
